import { ensureGtag } from "./gtag";

const EVENT_NAMES = {
  PageView: "page_view",
  Lead: "generate_lead",
  InitiateCheckout: "begin_checkout",
  Purchase: "purchase",
};

const configured = new Set();

const ga4 = {
  isValid: (pixel) => /^G-[A-Z0-9]{6,12}$/.test(pixel.id),

  load(pixels) {
    ensureGtag(pixels[0].id);
    pixels.forEach(({ id }) => {
      if (configured.has(id)) return;
      configured.add(id);
      // Page views are sent by the engine, once.
      window.gtag("config", id, { send_page_view: false, groups: "affiliate" });
    });
  },

  send(event, data, key, pixel) {
    const name = EVENT_NAMES[event];
    if (!name) return;
    const params = { send_to: pixel.id };
    if (data.value != null) {
      params.value = data.value;
      params.currency = data.currency;
    }
    if (event === "Purchase" && key) params.transaction_id = key;
    window.gtag("event", name, params);
  },
};

export default ga4;
